import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  overflow-x: auto;
  position: relative;
`;

const RowsWrapper = styled.div`
  flex: 1 0 auto;
`;

export { Container, RowsWrapper };
